import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/people/$siteId/profiles/$profileId",
)({
  component: () => {
    return <Outlet />;
  },
});
